module.exports = __webpack_public_path__ + "static/img/74.837bb9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/74.png
// module id = baP7
// module chunks = 0